<template>
    <csp-form-group-select-searchable :disabled="disabled" :form="insurancePolicyForm" :options="options"
        :property="property" :required="required"/>
</template>

<script>
    import Form from '@form/Form';
    import Container from '@services/Container';
    import InsuranceTypeEnum from '@js/enums/insurance/InsuranceTypeEnum';

    const insuranceRepository = Container.getInstance().getDamageInsuranceRepository();

    export default {
        props: {
            disabled: {
                type: Boolean,
                default: false,
            },
            insurancePolicyForm: {
                type: Form,
                required: true,
            },
            property: {
                type: String,
                required: true,
            },
            required: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                options: [],
                value: '',
            }
        },
        created() {
            insuranceRepository.findParentsForDropdown(InsuranceTypeEnum.INSURANCE)
                .then((options) => {this.options = options});
        },
    }
</script>
